export default __webpack_public_path__ + "static/media/subte.aec2c9a4.jpg";